import { INPUT_PARAM_DEFAULTS } from './constants';

export const parseInputParameters = values => ({
	vinMin: parseFloat(values.vinMin),
	vinMax: parseFloat(values.vinMax),
	vinNom: values.vinNom ? parseFloat(values.vinNom) : null,
	vout: parseFloat(values.vout),
	iout: parseFloat(values.iout),
	ambientTemperature: parseFloat(values.ambientTemperature),
	supplyType: values.supplyType,
	lineFrequency: parseInt(values.lineFrequency),
	isolated: values.isolated,
	automotiveDesign: values.automotiveDesign
});

// ambientTemperature=25&iout=2.5&isolated=false&lineFrequency=60&supplyType=DC&vinMax=5.025&vinMin=4.975&vout=3.3&topology=BUCK&ic=NCP3133AMNTXG
const ALLOWED_INPUT_PARAMS = [
	'vinMin',
	'ic',
	'vinMax',
	'topology',
	'vout',
	'iout',
	'ambientTemperature',
	'supplyType',
	'lineFrequency',
	'isolated'
];

export const areParamsValidDesignParams = values => {
	const valueKeys = new Set(Object.keys(values));
	for (const param of ALLOWED_INPUT_PARAMS) {
		if (!valueKeys.has(param)) {
			return false;
		}
	}
	return true;
};

export const handleReset = setValues => {
	setValues({
		vinMin: INPUT_PARAM_DEFAULTS.VIN_MIN[INPUT_PARAM_DEFAULTS.SUPPLY_TYPE],
		vinMax: INPUT_PARAM_DEFAULTS.VIN_MAX[INPUT_PARAM_DEFAULTS.SUPPLY_TYPE],
		vout: INPUT_PARAM_DEFAULTS.VOUT[INPUT_PARAM_DEFAULTS.SUPPLY_TYPE],
		iout: INPUT_PARAM_DEFAULTS.IOUT,
		ambientTemperature: INPUT_PARAM_DEFAULTS.AMB_TEMP,
		supplyType: INPUT_PARAM_DEFAULTS.SUPPLY_TYPE,
		lineFrequency: INPUT_PARAM_DEFAULTS.LINE_FREQUENCY,
		isolated: INPUT_PARAM_DEFAULTS.ISOLATED,
		automotiveDesign: INPUT_PARAM_DEFAULTS.AUTOMOTIVE_DESIGN
	});
};

export const checkForChanges = (isValid, values) =>
	isValid &&
	parseFloat(values.vinMin) === INPUT_PARAM_DEFAULTS.VIN_MIN[INPUT_PARAM_DEFAULTS.SUPPLY_TYPE] &&
	parseFloat(values.vinMax) === INPUT_PARAM_DEFAULTS.VIN_MAX[INPUT_PARAM_DEFAULTS.SUPPLY_TYPE] &&
	parseFloat(values.vout) === INPUT_PARAM_DEFAULTS.VOUT[INPUT_PARAM_DEFAULTS.SUPPLY_TYPE] &&
	parseFloat(values.iout) === INPUT_PARAM_DEFAULTS.IOUT &&
	parseFloat(values.ambientTemperature) === INPUT_PARAM_DEFAULTS.AMB_TEMP &&
	values.supplyType === INPUT_PARAM_DEFAULTS.SUPPLY_TYPE &&
	parseFloat(values.lineFrequency) === INPUT_PARAM_DEFAULTS.LINE_FREQUENCY &&
	values.isolated === INPUT_PARAM_DEFAULTS.ISOLATED &&
	values.automotiveDesign === INPUT_PARAM_DEFAULTS.AUTOMOTIVE_DESIGN;
